module.exports = __webpack_public_path__ + "static/other/gameCakeDecorating.57d60f89.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameCakeDecorating.json
// module id = 2629
// module chunks = 0